export default {
    "title": "English",

    "加载中...": "Loading...",
    "没有更多数据": "No more data",
    "暂无数据": "No data yet",
    "取消": "Cancel",
    "确认": "Confirm",
    "确定": "Sure",
    "完成": "Done",
    "我知道了": "I know",
    "开始": "Start",
    "结束": "End",
    "提示": "Tips",
    "提交": "Submit",
    "请输入": "Please Enter",
    "请输入33": "Please enter 33",
    "请选择": "Select here",
    "请选择33": "Please select 33",
    "成功": "Success",
    "失败": "Failed",
    "错误": "Error",
    "复制": "Copy",
    "复制成功": "Copy Success",
    "复制失败": "Copy Failed",
    "© 2009-2025 XXX 版权所有": "© 2009-2025 XXX All Rights Reserved",
    
    "星期一": "Mon",
    "星期二": "Tue",
    "星期三": "Wed",
    "星期四": "Thu",
    "星期五": "Fri",
    "星期六": "Sat",
    "星期日": "Sun",

    "一月": "January",
    "二月": "February",
    "三月": "March",
    "四月": "April",
    "五月": "May",
    "六月": "June",
    "七月": "July",
    "八月": "August",
    "九月": "September",
    "十月": "October",
    "十一月": "November",
    "十二月": "December",
    
    "语言": "Language",
    "立即开始": "Get Started Now",
    "登录": "Log in",
    "注册": "Sign up",
    "记住密码": "Remember password",
    "忘记密码": "Forgot password",
    "手机号": "Mobile Number",
    "密码": "Password",
    "登录密码": "Login Password",
    "确认密码": "Confirm Password",
    "邀请码": "Referral Code",
    "我同意": "I agree to",
    "条款&协议": "Terms and Conditions",
    "注册条款": "Registration Terms",
    "创建账号": "Create Account",
    "修改密码": "Change password",
    "请根据以下内容修改密码": "Please change your password according to the content below",
    "提现密码": "Withdrawal Password",
    "当前密码": "Current Password",
    "新密码": "New Password",
    "请再次输入新密码": "Please enter the new password again",
    "你确定要登出当前账号吗？": "Are you sure you want to log out of the current account?",
    "选择国家代码": "Select country code",

    "开始预订": "Start Booking",
    "订单历史": "Order History",
    "个人资料": "Profile",
    "会员资格": "Membership",
    "事件": "Event",
    "联系我们": "Contact Us",
    "钱包信息": "Wallet Info",
    "提现": "Withdrawal",
    "证书": "Cert",
    "设置": "Settings",
    "其他": "General",
    "安全中心": "Security center",
    "关于我们": "About Us",
    "常见问题": "FAQs",
    "用户ID": "User ID",
    "账户余额": "Account Balance",
    "信用评分": "Credit Score",
    "充值": "Recharge",
    "存款": "Deposit",
    "退出登录": "Log out",
    "立即查看": "Review now",

    "邀请好友": "Invite a friend",
    "复制你的邀请码，与好友分享": "Copy your code, share it with your friends",
    "当前等级": "Current",
    "佣金率": "Commission rate",
    "每日订单": "Daily Orders",

    "钱包余额": "Wallet Balance",
    "充值金额": "Deposit Amount",
    "支付类型": "Payment Type",
    "支付银行": "Payment Bank",
    "钱包地址": "Wallet Address",
    "二维码": "QR Code",
    "充值渠道": "Deposit Channel",
    "充值凭证": "Deposit Voucher",
    "请联系在线客服获取最新的存款信息。如果存款信息有误，将影响您的转账验证，导致转账失败，平台对此不承担任何责任。": "Please contact livechat agent for the latest deposit details. If the deposit is made to an incorrect details, it will affect the verification of your transfer, leading to failure, and the platform will not be held responsible for any issues.",
    "你还没有设置提现密码，请前往设置": "You haven't set a withdrawal password yet. Please go to settings.",
    "提现到": "Withdraw To",
    "暂无333可用": "No 333 available",
    "请先将333关联到您的账户，然后再进行提现。": "Please link 333 to your account before any withdrawal.",
    "链接333": "Link 333",
    "金额": "Amount",
    "提现金额": "Withdrawal amount",
    "加密钱包": "crypto wallet",
    "银行卡": "bank card",
    "钱包": "Wallet",
    "提现历史": "Withdraw History",
    "手续费": "Handling fee",
    "到账金额": "Amount received",
    "银行卡号": "Bank Card Number",
    "Pix账号": "Pix Account",
    "备注": "Remarks",
    "立即关联您的333": "Link your 333 now",
    "Pix类型": "Pix type",
    "地址": "Address",
    "网络": "Network",
    "持卡人姓名": "Cardholder's Name",
    "银行列表": "Bank List",
    "账户历史": "Account History",
    "你确定要删除此地址吗": "Are you sure you want to delete this address?",
    "你确定要删除此账号吗": "Are you sure you want to delete this account?",

    "全部": "All",
    "待处理": "Pending",
    "冻结中": "Frozen",
    "已完成": "Completed",
    "每日佣金": "Daily Commission",
    "总奖金": "Total Bonus",
    "冻结": "On Hold",
    "订单数量": "Order Number",
    "订单集数量": "Order Set Number",
    "现在开始": "Start Now",
    "热门预订": "Trending Bookings",
    "0条评论": "333 Reviews",
    "普通订单": "Normal Order",
    "价格": "Price",
    "佣金": "Comission",
    "评分": "Rating",
    "评论": "Comment",
    "选择评论": "Select Comment",

    "comment_1": `The tourism package was absolutely fantastic and exceeded all my expectations.`,
    "comment_2": `I had the most incredible experience with the tourism package I booked.`,
    "comment_3": `The attention to detail in the tourism package was remarkable.`,
    "comment_4": `I felt pampered and well taken care of throughout the entire tourism package.`,
    "comment_5": `The activities included in the tourism package were thrilling and exhilarating.`,
    "comment_6": `I can't recommend this tourism package enough; it truly made my vacation unforgettable.`,
    "comment_7": `From start to finish, the tourism package provided a seamless and enjoyable experience.`,
    "comment_8": `The itinerary of the tourism package was well-balanced, offering a mix of relaxation and adventure.`,
    "comment_9": `The guides and staff involved in the tourism package were friendly, knowledgeable, and accommodating.`,
    "comment_10": `The tourism package allowed me to immerse myself in the local culture and truly connect with the destination.`,
    "comment_11": `The accommodations included in the tourism package were luxurious and comfortable.`,
    "comment_12": `The transportation provided in the tourism package was convenient and hassle-free.`,
    "comment_13": `I felt like a VIP throughout the entire duration of the tourism package.`,
    "comment_14": `The variety of dining options included in the tourism package showcased the local cuisine beautifully.`,
    "comment_15": `The tourism package provided ample opportunities for breathtaking scenic views and natural wonders.`,
    "comment_16": `I met wonderful people and made lifelong friends during the tourism package.`,
    "comment_17": `The entertainment and cultural experiences offered in the tourism package were captivating and enriching.`,
    "comment_18": `I had the freedom to explore and discover hidden gems with the flexibility provided by the tourism package.`,
    "comment_19": `The value for money with this tourism package was outstanding.`,
    "comment_20": `The communication and organization leading up to the tourism package were excellent.`,
    "comment_21": `The tourism package offered a perfect balance of relaxation, adventure, and cultural immersion.`,
    "comment_22": `I felt safe and secure throughout the entire duration of the tourism package.`,
    "comment_23": `The tourism package provided unique and off-the-beaten-path experiences.`,
    "comment_24": `The attention given to sustainability and responsible tourism in this package was commendable.`,
    "comment_25": `The memories I made during the tourism package will stay with me forever.`,
    "comment_26": `The local guides' passion and expertise added an extra layer of depth to the tourism package.`,
    "comment_27": `The tourism package introduced me to new activities and experiences I would never have tried otherwise.`,
    "comment_28": `I felt like I had stepped into a different world with the tourism package.`,
    "comment_29": `The tourism package allowed me to relax and unwind while exploring a new destination.`,
    "comment_30": `I would book this tourism package again without hesitation; it was truly remarkable.`,

    "需要帮助吗？": "Need help ?",
    "点击下方按钮链接进入我们的客服在线聊天": "Click button below link to our customer live chat",
    "客服时间": "Customer Service Hours",
    "联系客服": "Contact customer service",

    "欢迎来到": "Welcome to",
    "index_text_1": "We lead the way in accommodation marketing, offering access to over 2.7 million hotels worldwide through 320+ suppliers. Our services also include air and train tickets, airport transfers, and car rentals.",
    "从今天开始": "Start today",

    "home_1_1": `The tour booking system that will grow your business by 35%`,
    "home_1_2": `Online booking software designed for tour operators, activity providers and resellers to automate, save time, get connected and grow.`,
    "home_2_t": `Tour management made easy`,
    "home_2_1": `Get the booking system features you need to manage tours and activities end to end. Rezdy tour operator booking`,
    "home_2_2": `software helps you manage your experience-based business by automating tasks like booking management,`,
    "home_2_3": `communications, reporting and billing. Fully flexible and customized to your business needs. Get time back to`,
    "home_2_4": `focus on delivering delightful experiences for your guests.`,
    "home_3_t": `Connecting supply with demand`,
    "home_3_1": `Rezdy distribution platform offers award-winning connections with thousands of global & local resellers like`,
    "home_3_2": `Viator and Google Things to do, plus tools to manage each channel seamlessly. Connect your tours easily via a`,
    "home_3_3": `single managed connection to unlock new revenue streams. Rezdy connects you to the largest independent supply`,
    "home_3_4": `and distribution network across the whole Experience Industry.`,
    "home_4_t": `Grow your business with leading integration partners in the travel industry`,
    "home_4_1": `We connect you with tourism industry partners around the world, 25k+ resellers globally and locally, 100k+`,
    "home_4_2": `experiences worldwide.`,
    "home_5_t": `Rezdy gets results. Here's how we help operators around the world thrive:`,
    "home_5_1": `Average increase in direct online bookings`,
    "home_5_2": `More revenue from OTAs and channel partners`,
    "home_5_3": `Hours saved annually in booking management`,
    "©版权所有XXX2025": "© Copyright XXX 2025",
    // "xxx": "vvv",
    // "xxx": "vvv",
    // "xxx": "vvv",
    // "xxx": "vvv",
    // "xxx": "vvv",
    // "xxx": "vvv",
}